<template>
  <div class="k-onboarding__quest-wrapper">
    <div class="k-onboarding__quest">
      <div class="k-onboarding__height-label">
        <label for="onbording_height">Укажите ваш рост:</label>
      </div>
      <div class="k-onboarding__height-input-wrapper">
        <input
          class="k-onboarding__input k-onboarding__height-input jq-onboarding-input number-no-controls"
          type="number"
          placeholder="178"
          title="Рост"
          id="onbording_height"
          v-model="height"
          v-focus
        />
      </div>
      <a
        href="#"
        @click.prevent="processSubmit"
        :class="['k-onboarding__quest-next', { active: validHeight }]"
      >Далее</a>
      <slot />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: "OnboardingHeight",
  props: {
    editProfile: Object,
  },
  computed: {
    height: {
      get() {
        if (this.editProfile) return this.editProfile.height;
        return this.$store.getters.getProfileHeight;
      },
      set(value) {
         if (!this.editProfile) {
          this.$store.dispatch("setProfileData", { height: value });
        } else {
          this.editProfile.height = value;
        }
      }
    },
    validHeight() {
      return this.height && !isNaN(this.height);
    },
    currentCreatedProfile() {
      return this.$store.getters.getUserFamily.find(el => el.is_main === 't')
    }
  },
  methods: {
    ...mapActions([
      'updateProfile',
    ]),
    async processSubmit() {
      if (this.validHeight) {
        if (this.currentCreatedProfile && !this.editProfile) {
          await this.updateProfile({
            id: this.currentCreatedProfile.id,
            height: this.height,
          })
        }
        this.$router.push({ name: "OnboardingWeight" });
      }
    }
  }
};
</script>

<style scoped>
</style>
